import React from "react";
import { Box, Typography } from "@mui/material";
import { TEXT_COLOR_PRIMARY } from "../../../constants/colors";
import { FONT_SIZE } from "../../../constants/fontSizes";
import { useIsDesktop } from "../../shared/hooks/useIsDesktop";

/**
 * 人物の基本情報サマリー
 * - イニシャル
 * - 年齢 / 性別
 */
const PersonSummary = ({ name, age, gender }) => {
  const isDesktop = useIsDesktop();
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "baseline",
        gap: 1.5,
      }}
    >
      {/* イニシャル */}
      <Typography
        fontWeight="bold"
        sx={{
          color: TEXT_COLOR_PRIMARY,
          fontSize: isDesktop ? "3.4rem" : "2rem",
          lineHeight: 1,
        }}
      >
        {name}
      </Typography>

      {/* 年齢 / 性別 */}
      <Typography
        sx={{
          color: TEXT_COLOR_PRIMARY,
          fontSize: FONT_SIZE.SM,
          whiteSpace: "nowrap",
        }}
      >
        {age}歳 / {gender}
      </Typography>
    </Box>
  );
};

export default PersonSummary;
